module.exports = __webpack_public_path__ + "2021315:5185b0787db23a9cf11c/img/featured-section@1x.02a824a.gif";